import React from 'react';

// Composant Tooltip
const Tooltip = ({ children, text, color = 'black', arrowPosition = 'left', className = "" }) => {
    const colorClasses = {
        'black': 'bg-black before:bg-black',
        'lime':  'bg-lime-500 before:bg-lime-500',
        'red': 'bg-red-500 before:bg-red-500',
        'cyan': 'bg-cyan-500 before:bg-cyan-500',
        'orange': 'bg-orange-500 before:bg-orange-500',
        'gray': 'bg-gray-800 before:bg-gray-800',
        'mdark': 'bg-mdark before:bg-mdark',
        'mgray': 'bg-mgray before:bg-mgray',
    }

    // Classes de base pour le tooltip
    const baseClasses = `${children ? 'absolute' : '' } shadow-lg group-hover:block text-white font-semibold px-3 py-[6px] text-[13px] right-0 left-0 w-max mx-auto rounded`;


    // Gérer la position de la flèche
    const arrowClasses = 
        arrowPosition === 'left' 
        ? 'before:-left-1 before:top-1/2 before:-translate-y-1/2' 
        : arrowPosition === 'right'
            ? 'before:-right-1 before:top-1/2 before:-translate-y-1/2'
            : arrowPosition === 'top'
                ? 'before:-top-1 before:left-1/2 before:-translate-x-1/2'
                : 'before:-bottom-1 before:left-1/2 before:-translate-x-1/2'
    return (
        <div className={`absolute ${className}`}>
            {children}
            <div className={`${baseClasses} ${colorClasses[color]} tooltip before:w-4 before:h-4 before:rotate-45 before:absolute before:z-[-1] ${arrowClasses}`}>
                {text}
            </div>
        </div>
    );
};

export default Tooltip;